import { getEcommerceByIds, addToWishlistEvent } from "@src/analytics";
import updateHeaderShortlistCount from "@src/containers/components/Header/shortlist";

const favoriteListKey = "favorite_list";

export function addFavoriteItem(id: string): void {
  const list: string[] = getFavoriteList();
  if (!list.includes(id)) {
    list.push(id);
    localStorage?.setItem(favoriteListKey, JSON.stringify(list));
    updateHeaderShortlistCount();
    // GTM push `add_to_wishlist` event
    getEcommerceByIds([id]).then((ecommerce) => {
      addToWishlistEvent(ecommerce);
    });
  }
}

export function removeFavoriteItem(id: string): void {
  const list: string[] = getFavoriteList();
  const index: number = list.indexOf(id);
  if (index > -1) {
    list.splice(index, 1);
    localStorage?.setItem(favoriteListKey, JSON.stringify(list));
    updateHeaderShortlistCount();
  }
}

export function getFavoriteList(): string[] {
  return JSON.parse(localStorage?.getItem(favoriteListKey) || "[]");
}

export function isFavorite(id: string): boolean {
  const list = getFavoriteList();
  return list.includes(id);
}

export function getFavoriteCount(): number {
  const list = getFavoriteList();
  return list.length;
}

export function toggleFavorite(targetElement: Element | null) {
  const propertyId = targetElement?.getAttribute("data-property-id");

  if (propertyId) {
    if (targetElement?.getAttribute("data-favorite") === "true") {
      // remove from favorite
      targetElement?.setAttribute("data-favorite", "false");
      removeFavoriteItem(propertyId);
    } else {
      // add to favorite
      targetElement?.setAttribute("data-favorite", "true");
      addFavoriteItem(propertyId);
    }
  }
}
